// Cache localStorage des catalogues ready : évite tout rechargement réseau à la
// navigation. La version serveur reste la référence (revalidation via /status).
const CATALOG_KEY_PREFIX = "expertloop.i18n.catalog.";
export const LOCALE_STORAGE_KEY = "expertloop.i18n.locale";
function storage() {
    try {
        return typeof window !== "undefined" ? window.localStorage : null;
    }
    catch {
        return null;
    }
}
export function readCachedCatalog(locale) {
    const store = storage();
    if (!store)
        return null;
    try {
        const raw = store.getItem(`${CATALOG_KEY_PREFIX}${locale}`);
        if (!raw)
            return null;
        const parsed = JSON.parse(raw);
        if (typeof parsed !== "object" ||
            parsed === null ||
            typeof parsed.version !== "number" ||
            typeof parsed.messages !== "object" ||
            parsed.messages === null) {
            return null;
        }
        return parsed;
    }
    catch {
        return null;
    }
}
export function writeCachedCatalog(catalog) {
    const store = storage();
    if (!store)
        return;
    try {
        const entry = {
            locale: catalog.locale,
            version: catalog.version,
            sourceVersion: catalog.sourceVersion,
            messages: catalog.messages,
            savedAt: Date.now(),
        };
        store.setItem(`${CATALOG_KEY_PREFIX}${catalog.locale}`, JSON.stringify(entry));
    }
    catch {
        // non bloquant (quota, navigation privée…)
    }
}
export function readStoredLocaleChoice() {
    const store = storage();
    if (!store)
        return null;
    try {
        return store.getItem(LOCALE_STORAGE_KEY);
    }
    catch {
        return null;
    }
}
export function writeStoredLocaleChoice(locale) {
    const store = storage();
    if (!store)
        return;
    try {
        store.setItem(LOCALE_STORAGE_KEY, locale);
    }
    catch {
        // non bloquant
    }
}
//# sourceMappingURL=catalog-cache.js.map